module.exports = __webpack_public_path__ + "static/8-1df7071b5b102650b435b93572dd445b.jpg";